import { Component, OnInit, inject } from '@angular/core';
import { AppToastService } from 'app/core/services/app-toast.service';
import { LimitOffsetPaging } from '../../../core/models/paged-results/limit-offset-paging.model';
import { PrescriberIncorrectInformationRequest } from '../../../core/models/prescriber-incorrect-information-request.model';
import {
  PrescriberIncorrectInformationRequestsService,
  PagedPrescriberIncorrectInformationRequests,
} from '../../../core/services/prescriber-incorrect-information-requests.service';
import { DatePipe } from '@angular/common';
import { PaginationHeaderComponent } from '../../../shared/components/pagination-header/pagination-header.component';
import { PrescriberNameComponent } from '../../../shared/components/prescriber-name/prescriber-name.component';
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-capture-admin-prescriber-incorrect-information-requests',
    templateUrl: './capture-admin-prescriber-incorrect-information-requests.component.html',
    styleUrls: ['./capture-admin-prescriber-incorrect-information-requests.component.scss'],
    imports: [PaginationHeaderComponent, PrescriberNameComponent, PaginationComponent, MatProgressSpinner, DatePipe]
})
export class CaptureAdminPrescriberIncorrectInformationRequestsComponent implements OnInit {
  private prescriberIncorrectInformationRequestsService = inject(PrescriberIncorrectInformationRequestsService);
  private toastService = inject(AppToastService);

  prescriberIncorrectInformationRequests: PrescriberIncorrectInformationRequest[] = [];
  paging: LimitOffsetPaging = LimitOffsetPaging.empty;
  loading = true;

  ngOnInit() {
    this.init();
  }

  onPageSizeChange(size) {
    this.paging.pageSize = size;
    this.getPrescriberIncorrectInformationRequests(this.paging.currentPage);
  }

  onPageChange(page) {
    this.getPrescriberIncorrectInformationRequests(page);
  }

  private init() {
    this.getPrescriberIncorrectInformationRequests(this.paging.currentPage);
  }

  getPrescriberIncorrectInformationRequests(page) {
    this.loading = true;
    this.prescriberIncorrectInformationRequestsService
      .getList(page, this.paging.pageSize)
      .subscribe((result: PagedPrescriberIncorrectInformationRequests) => {
        this.prescriberIncorrectInformationRequests = result.prescriberIncorrectInformationRequests;
        this.paging = result.meta.paging;
        this.loading = false;
      });
  }

  resolve($event, request) {
    $event.preventDefault();

    this.prescriberIncorrectInformationRequestsService.update(request, { resolved: true }).subscribe(() => {
      this.toastService.show('Request resolved!', { cssClass: 'bg-success-subtle' });
      this.getPrescriberIncorrectInformationRequests(this.paging.currentPage);
    });
  }

  unresolve($event, request) {
    $event.preventDefault();

    this.prescriberIncorrectInformationRequestsService.update(request, { resolved: false }).subscribe(() => {
      this.toastService.show('Request unresolved!', { cssClass: 'bg-success-subtle' });
      this.getPrescriberIncorrectInformationRequests(this.paging.currentPage);
    });
  }
}
